import { mutatorAction } from 'satcheljs';
import store from '../store/store';
import { createFontStyles } from '@fluentui/style-utilities';

const mutateFontMutator: (locale: string) => void = mutatorAction(
    'MUTATE_FABRIC_FONT',
    (locale: string): void => {
        store().fonts = createFontStyles(locale);
    }
);
export default mutateFontMutator;
